import type { ImgHTMLAttributes } from 'react';

// ─────────────────────────────────────────────────────────────────────────────
// CoverImage — thin <img> wrapper that applies a stored CSS object-position
// focal point on top of object-cover. Non-destructive display-side companion
// to FocalPointPicker: the file is never re-cropped, we just tell the browser
// which part of it to keep visible when the frame clips the rest.
//
// Callers still own object-cover / sizing via `className` — this component
// only owns the `objectPosition` inline style (a plain <img> can't otherwise
// take a dynamic per-instance object-position without one).
// ─────────────────────────────────────────────────────────────────────────────

export function CoverImage({
  src,
  alt = '',
  objectPosition,
  className,
  style,
  ...rest
}: {
  src: string;
  alt?: string;
  objectPosition?: string;
} & Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'>) {
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={{ ...style, objectPosition: objectPosition ?? '50% 50%' }}
      {...rest}
    />
  );
}
